<template>
  <div>
    <!--notif jadwal-->
    <v-card tile flat class="my-5 bg-card">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5 black--text">
            <base-breadcrumbs :items="breadcrumbs" class="px-0 pb-0" />
            <div class="my-2" />
            <div class="headline">{{ $getDeepObj(detail, 'nama') || '' }}</div>
            <div class="body-1">
              <v-icon small left>mdi-clock</v-icon>
              <template v-if="isDaring">
                {{ $localDate($getDeepObj(detail, 'paud_periode.data.tgl_diklat_mulai')) }} s/d
                {{ $localDate($getDeepObj(detail, 'paud_periode.data.tgl_diklat_selesai')) }}
              </template>
              <template v-else>
                {{ $localDate($getDeepObj(detail, 'tgl_mulai')) }} s/d
                {{ $localDate($getDeepObj(detail, 'tgl_selesai')) }}
              </template>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title class="pa-0">
        <base-table-header
          @search="onSearch"
          :btnFilter="false"
          :btnAdd="$allow(`${akses}.create`)"
          @add="onAdd"
          @reload="onReload"
          @filter="onFilter"
        >
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text">
              <b>{{ total }}</b> Kelas Diklat
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterStatus"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col class="py-2" cols="12" :md="jenis === 'refreshment' ? 4 : 3">
                      <v-list-item class="px-0" @click="onDetail(item)">
                        <v-list-item-avatar color="primary">
                          <v-icon dark>mdi-teach</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 mt-3">
                          <div class="label--text">Nama Kelas</div>
                          <div class="body-1 black--text">
                            <strong>{{ $getDeepObj(item, 'nama') || '-' }}</strong>
                          </div>
                          <div v-if="jenis === 'bcmp'" class="grey--text mb-1">
                            <i>Angkatan {{ $getDeepObj(item, 'angkatan') }}</i>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <template v-if="jenis === 'bcmp'">
                      <v-col class="py-0" cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <div class="label--text">Peserta</div>
                            <span class="body-1">
                              {{ $getDeepObj(item, 'jml_peserta') || 0 }}
                            </span>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <div class="label--text">Pengajar</div>
                            <span class="body-1">
                              {{ $getDeepObj(item, 'jml_pengajar') || 0 }}
                            </span>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <div class="label--text">Admin Kelas</div>
                            <span class="body-1">
                              {{ $getDeepObj(item, 'jml_admin') || 0 }}
                            </span>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col class="py-0" cols="12" md="2">
                        <v-list-item v-if="!['refreshment'].includes(jenis)" class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <div class="label--text">Mata Pelajaran</div>
                            <span>
                              {{
                                (objMapel[$getDeepObj(item, 'paud_mapel_kelas_id')] &&
                                  objMapel[$getDeepObj(item, 'paud_mapel_kelas_id')]['nama']) ||
                                '-'
                              }}
                            </span>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" :md="['refreshment'].includes(jenis) ? 3 : 2">
                        <v-list-item class="px-0 mt-2">
                          <v-list-item-content class="py-0">
                            <v-list-item-title>
                              <div class="label--text">Status</div>
                            </v-list-item-title>
                            <v-list-item-subtitle class="link black--text body-2">
                              <v-chip :color="getColor($getDeepObj(item, 'k_verval_paud'))" dark small>
                                {{ $getDeepObj(item, 'm_verval_paud.data.keterangan') || 'Kandidat' }}
                              </v-chip>
                              <template v-if="[4, 5].includes(Number(item && item.k_verval_paud))">
                                <v-btn class="ml-1" rounded outlined x-small color="orange" @click="onCatatan(item)">
                                  <v-icon left>mdi-file-edit</v-icon> Catatan
                                </v-btn>
                              </template>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content>
                            <div class="label--text">Aksi Selanjutnya</div>
                            <template v-if="Number(item.k_verval_paud) === 6 && jenis && jenis === 'daring' && !isLpd">
                              <v-btn
                                color="success"
                                small
                                dark
                                :disabled="
                                  $isTutupLms
                                    ? true
                                    : !$getDeepObj(item, 'lms_url') ||
                                      [1].includes(Number((detail && detail.paud_periode_id) || 0))
                                "
                                @click="onLms($getDeepObj(item, 'lms_url'))"
                              >
                                <v-icon left>mdi-link</v-icon>
                                Menuju LMS
                              </v-btn>
                            </template>
                            <template v-else>
                              <v-btn
                                :disabled="!item.is_siap_ajuan"
                                v-if="+item.k_verval_paud < 2 && $allow('lpd-kelas-ajuan.create')"
                                color="secondary"
                                depressed
                                small
                                @click="onAjuan(item)"
                                >Ajukan</v-btn
                              >
                              <v-btn
                                v-if="+item.k_verval_paud > 1 && $allow('lpd-kelas-ajuan.delete')"
                                color="secondary"
                                outlined
                                depressed
                                small
                                @click="onBatalAjuan(item)"
                                >Batal Ajuan</v-btn
                              >
                            </template>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col v-if="catatans[item.id]" cols="12" sm="12" md="12" class="px-0 pb-0">
                        <v-alert text color="orange" class="ml-3">
                          <div class="black--text body-2">
                            <b>Catatan:</b> <br />
                            {{ $getDeepObj(item, 'alasan') }}
                          </div>
                        </v-alert>
                      </v-col>
                    </template>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full
      ref="modal"
      colorBtn="primary"
      generalError
      :title="formulir.title"
      :useSave="formulir.useSave"
      @save="onSave"
    >
      <component
        ref="formulir"
        :is="formulir.form"
        :type="formulir.type"
        :mapels="mapels"
        :detail="detail"
        :masters="masters"
        :initValue="formulir.init"
        :jenis="jenis"
        @reload="onDetail"
      ></component>
    </base-modal-full>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import DetailKelas from '../../formulir/Detail';
import FormDiklat from '../../formulir/FormDiklat';
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs';
import mixin from '../base/mixin';
import list from '@mixins/list';
import actions from './actions';
export default {
  mixins: [list, mixin],
  components: { FormDiklat, DetailKelas, BaseBreadcrumbs },
  data() {
    return {
      formulir: {},
      actions: actions,
      mapels: [],
      detail: {},
      catatans: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
      groups: (state) => state?.data?.groups ?? {},
    }),

    isLpd() {
      return this.$mapForMaster(this.groups).filter((s) => [172].includes(s.value)) || [];
    },

    jenis() {
      return (this.$route && this.$route.meta && this.$route.meta.tipe) || 'daring';
    },

    isDaring() {
      return this.jenis === 'daring';
    },

    breadcrumbs() {
      return [
        {
          text: `${
            this.jenis === 'bcmp' ? 'Bimtek BCMP' : this.jenis === 'refreshment' ? 'Bimtek PPM & PPTM' : 'Daftar Diklat'
          }`,
          to: `kelola-diklat${
            this.jenis === 'daring'
              ? ''
              : this.jenis === 'bcmp'
              ? '-bcmp'
              : this.jenis === 'refreshment'
              ? '-refreshment'
              : '-luring'
          }`,
        },
        { text: this.$getDeepObj(this, 'detail.nama') },
      ];
    },

    configs() {
      const M_PROPINSI = this.masters.m_propinsi || {};
      const M_KOTA = this.masters.m_kota || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 12 }, { cols: 12 }],
        disabled: [],
      };
    },

    formFilter() {
      return [
        {
          label: 'Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        },
      ];
    },

    filtersMaster() {
      return {
        k_propinsi: this.masters && this.masters.m_propinsi,
        k_kota: this.masters && this.masters.m_kota,
      };
    },

    diklatId() {
      return this.$route.params.diklat_id;
    },

    objMapel() {
      return this.$arrToObj(this.$getDeepObj(this, 'mapels') || [], 'id');
    },

    akses() {
      const acl = {
        daring: 'lpd-kelas',
        luring: 'lpd-luring-kelas',
        bcmp: 'kelas-bcmp',
        refreshment: 'lpd-bimtek-kelas',
      };

      return acl[this.jenis];
    },
  },
  created() {
    Object.assign(this.attr, { jenis: this.jenis });
    this.getMasters({
      name: ['m_propinsi', 'm_kota'].join(';'),
      filter: {
        0: {
          k_propinsi: {
            op: '<',
            val: 90,
          },
        },
      },
    });

    if (!['bcmp', 'refreshment'].includes(this.jenis)) this.listMapels();
    this.fetchDiklat();
  },
  mounted() {
    Object.assign(this.attr, { diklat_id: this.diklatId });
  },
  methods: {
    ...mapActions('diklatKelas', ['fetch', 'create', 'update', 'action', 'getDetail', 'getMapels', 'downloadList']),
    ...mapActions('diklat', {
      getDiklat: 'getDetail',
    }),

    allow(action, data) {
      let disabled = false;
      const isAjuan = [2, 3, 4, 6].includes((data && data.k_verval_paud) || 1);
      switch (action.event) {
        case 'onAktif':
          disabled = !Number(this.$getDeepObj(data, 'akun.is_aktif') || 0);
          break;
        case 'onNonAktif':
          disabled = Number(this.$getDeepObj(data, 'akun.is_aktif') || 0);
          break;
        case 'onEdit':
          disabled = this.$allow(`${this.akses}.update`) && !isAjuan;
          break;
        case 'onDeleteKelas':
          disabled =
            this.jenis == 'bcmp' ? this.$allow('kelas-bcmp.delete') : !isAjuan && this.$allow(`${this.akses}.delete`);
          break;
        default:
          disabled = this.$allow(action.akses, data.policies);
          break;
      }
      return disabled;
    },

    onCatatan(data) {
      const id = data.id;
      if (this.catatans && this.catatans[id]) {
        this.$delete(this.catatans, id);
      } else {
        this.$set(this.catatans, id, true);
      }
    },

    onShow(item) {
      this.$router.push({ name: 'diklat-kelas-detail', params: { dikalt_id: this.diklatId, kelas_id: item.id } });
    },

    onLms(url) {
      window.open(url, '_blank');
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #ffab91;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
